export default __webpack_public_path__ + "static/image-03-480x298-61325ef71e66da52a4df4346e516e0db.jpg";